import type { UrlParamDefinition } from './UrlParams'

/**
 * URL-параметры, специфичные для платформы VK.
 * Эти параметры передаются платформой VK при запуске игры или мини-приложения.
 */
export const VK_URL_PARAMS: readonly UrlParamDefinition[] = [
    {
        name: 'vk_access_token_settings', //
        description: 'Список прав доступа пользователя, разделённых запятыми (например, `friends,stories,wall`)',
        group: 'vk',
    },
    {
        name: 'vk_app_id', //
        description: 'Идентификатор запущенного приложения из его настроек',
        group: 'vk',
    },
    {
        name: 'vk_are_notifications_enabled', //
        description: 'Информация о разрешённых уведомлениях: `0` — запрещены, `1` — разрешены',
        group: 'vk',
    },
    {
        name: 'vk_chat_id', //
        description: 'ОПЦИОНАЛЬНЫЙ. Идентификатор чата. Передаётся, если приложение было запущено из чата',
        group: 'vk',
    },
    {
        name: 'vk_is_app_user', //
        description: 'Информация об установке приложения: `0` — не установлено, `1` — установлено',
        group: 'vk',
    },
    {
        name: 'vk_is_favorite', //
        description: 'Информация о добавлении в избранное: `0` — не добавлено, `1` — добавлено',
        group: 'vk',
    },
    {
        name: 'vk_is_play_machine', //
        description: '`1`, если игра запущена через Play Machine (специальное приложение для Flash-игр), иначе `0` или не передаётся',
        group: 'vk',
    },
    {
        name: 'vk_is_widescreen', //
        description: '`1`, если игра запущена в широкоформатном режиме, иначе `0`. Используется только для Web-игр',
        group: 'vk',
    },
    {
        name: 'vk_language', //
        description: 'Язык интерфейса приложения: `ru`, `uk`, `ua`, `en`, `be`, `kz`, `pt`, `es`',
        group: 'vk',
    },
    {
        name: 'vk_platform', //
        description: 'Платформа запуска: `desktop_web`, `mobile_android`, `mobile_iphone`, `mobile_web` и другие (см. документацию VK)',
        group: 'vk',
    },
    {
        name: 'vk_ref', //
        description: 'Источник запуска приложения (см. документацию VK для списка возможных значений)',
        group: 'vk',
    },
    {
        name: 'vk_request_key', //
        description: 'ОПЦИОНАЛЬНЫЙ. Ключ запроса о помощи или приглашения друга. Используется для отслеживания конверсии. Параметр не используется в мини-приложениях',
        group: 'vk',
    },
    {
        name: 'vk_testing_group_id', //
        description: 'ОПЦИОНАЛЬНЫЙ. Идентификатор тестовой группы, в которой состоит пользователь. Если пользователь не состоит в тестовой группе, параметр не передаётся',
        group: 'vk',
    },
    {
        name: 'vk_ts', //
        description: 'Время генерации подписи параметров запуска (используется вместе с параметром `sign`)',
        group: 'vk',
    },
    {
        name: 'vk_user_id', //
        description: 'Идентификатор пользователя, запустившего приложение. Используется для авторизации пользователя',
        group: 'vk',
    },
    {
        name: 'sign', //
        description: 'Base64-строка — подпись параметров запуска. Используется для обнаружения подмены параметров третьими лицами',
        group: 'vk',
    },
] as const
